import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

import RadioButton from "../../UI/radio-buttons/radio-button";
import Button from "../../UI/button/button.component";
import { ButtonColumnContainer } from "../../../global.styles";

type SearchUsersBookingsProps = {
  userId: string;
};

const SearchUsersBookings: FC<SearchUsersBookingsProps> = ({ userId }) => {
  const navigate = useNavigate();

  const [searchType, setSearchType] = useState("active");

  // Show bookings navigates to the search bookings page with the userId and searchType
  const handleShowBookings = () => {
    const queryParams = new URLSearchParams({
      customerId: userId,
      searchType: searchType,
    }).toString();
    navigate(`/boss/manage-bookings?${queryParams}`);
  };

  return (
    <>
      <RadioButton
        label="Active Bookings"
        id="active"
        name="searchType"
        value="active"
        checked={searchType === "active"}
        onChange={() => setSearchType("active")}
      />
      <RadioButton
        label="All Bookings"
        id="all"
        name="searchType"
        value="all"
        checked={searchType === "all"}
        onChange={() => setSearchType("all")}
      />
      <ButtonColumnContainer>
        <Button onClick={handleShowBookings}>Show Bookings</Button>
      </ButtonColumnContainer>
    </>
  );
};

export default SearchUsersBookings;
